<script setup>
import { ref, defineProps, onMounted, reactive, watch } from "vue";
import ElevateESFEventDetail from "./ElevateESFEventDetail.vue";

const props = defineProps({
  events: Array,
});

const commands = reactive([]);
const eventTypes = ["Process:Auth:Exec", "Process:Exec"];
const signingIds = [
  "com.apple.sh",
  "com.apple.bash",
  "com.apple.zsh",
  "com.apple.tcsh",
  "com.apple.ksh",
  "com.apple.csh",
];
const shellType = ["bash", "bash", "zsh", "tcsh", "ksh", "csh"];
const terminalApps = ["iTerm2", "Terminal", "Code Helper"];
const commandsToHide = [
  "/bin/sh -c which ps",
  "/bin/sh -c /bin/ps -ax -o pid=,ppid=,pcpu=,pmem=,command=",
  "/bin/ps -ax -o pid=,ppid=,pcpu=,pmem=,command=",
  "which ps",
];
const searchValue = ref("");
const fieldNames = [
  { fieldName: "customReference", displayName: "Elevation Session ID" },
  { fieldName: "eventtype", displayName: "Event Type" },
  { fieldName: "isplatform", displayName: "Apple Signed Binary" },
  { fieldName: "pid", displayName: "Process ID" },
  { fieldName: "ppid", displayName: "Parent Process ID" },
  { fieldName: "processpath", displayName: "Process Path" },
  { fieldName: "signingid", displayName: "Signing ID" },
  { fieldName: "target", displayName: "Target" },
  { fieldName: "username", displayName: "Username" },
  { fieldName: "xxx", displayName: "xxx" },
];
const filterTerminalApps = ref(true);

function getDisplayName(fieldName) {
  let field = fieldNames.find((field) => field.fieldName === fieldName);
  return field ? field.displayName : fieldName;
}

function isTerminalApp(event) {
  if (!event.processTree) {
    console.log("No process tree");
    return false;
  }
  var result = false;
  event.processTree.forEach((process) => {
    if (terminalApps.includes(process.name)) {
      console.log("Terminal App Found");
      result = true;
      return;
    }
  });
  return result;
}

function findCommands() {
  let matching = props.events.filter((event) => {
    return (
      eventTypes.includes(event.eventtype) &&
      signingIds.includes(event.sourceSigningId)
    );
  });
  matching.forEach((event) => {
    // convert event.arguments array to a space seperated string
    let command = event.arguments.join(" ");
    // convert event.timestamp from timestamp in millisecnds on human readable format
    let time = new Date(event.timestamp).toLocaleString();
    let shellTypeIndex = signingIds.indexOf(event.sourceSigningId);
    var adding = true;
    if (filterTerminalApps.value) {
      adding = isTerminalApp(event);
      if (commandsToHide.includes(command)) {
        adding = false;
      }
    }

    if (adding) {
      commands.push({
        shellType: shellType[shellTypeIndex],
        command: command,
        eventType: time,
        event: event,
        time: time,
      });
    }
  });
}

const headers = [
  { text: "Shell Type", value: "shellType" },
  { text: "Command", value: "command" },
  { text: "TimeStamp", value: "time" },
];

onMounted(() => {
  findCommands();
});

watch(filterTerminalApps, () => {
  commands.length = 0;
  findCommands();
});

function searchFields() {
  return headers.map((header) => header.value);
}

function sortObject(object) {
  let sortedObject = {};
  Object.keys(object)
    .sort()
    .forEach((key) => {
      sortedObject[key] = object[key];
    });
  return sortedObject;
}

function shouldShowField(field, value) {
  if (!value) {
    return false;
  }
  if (Array.isArray(value)) {
    return value.length > 0;
  }
  let blockKeys = ["_id", "serialNumber", "licenseName", "__v"];
  if (blockKeys.includes(field)) {
    return false;
  }
  return true;
}
</script>

<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-card-title>
          <v-row>
            <v-col cols="auto"><h3>Shell Commands</h3></v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto"
              ><v-checkbox
                v-model="filterTerminalApps"
                label="Show Only Terminal Commands"
                density="compact"
                hide-details
              ></v-checkbox
            ></v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <EasyDataTable
            :items="commands"
            :headers="headers"
            :search-field="searchFields()"
            :search-value="searchValue"
            theme-color="#e7541e"
            empty-message="No Shell Commands Found"
          >
            <template #expand="item">
              <ElevateESFEventDetail :event="item.event" />
            </template>
          </EasyDataTable>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
